import { createSlice } from '@reduxjs/toolkit';

export const initialState = null;

export const slice = createSlice({
  name: 'selectedAddress',
  initialState,
  reducers: {
    setSelectedAddress: (state, { payload }) => payload,
    setInitialState: () => initialState
  }
});

export const { setSelectedAddress, setInitialState } = slice.actions;

export const selectedAddress = (state) => state.selectedAddress;

export default slice.reducer;
